import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

function getUniqueAttributes(product_variant) {
  if (!product_variant?.product_attributes) return [];
  const seen = new Set();
  return product_variant.product_attributes.filter((attr) => {
    const name = attr.attribute_value?.attribute?.name;
    if (seen.has(name)) return false;
    seen.add(name);
    return true;
  });
}

export default function ordersDetailsTableData(items) {
  console.log("items are", items);
  return {
    columns: [
      { Header: "الصورة", accessor: "image", align: "center" },
      { Header: "اسم المنتج", accessor: "name", align: "center" },
      { Header: "الكمية", accessor: "quantity", align: "center" },
      { Header: "سعر المنتج", accessor: "price", align: "center" },
      { Header: "المتغيرات", accessor: "attributes", align: "center" },
    ],
    rows: items.map((item) => {
      let imageUrl = item.product_variant?.image || item.product?.medias?.[0]?.file_name || "";
      let attributes = [];
      if (item.product_variant) {
        attributes = getUniqueAttributes(item.product_variant).map(
          (attr) => `${attr.attribute_value?.attribute?.name}: ${attr.attribute_value?.value}`
        );
      }
      return {
        image: <MDAvatar src={imageUrl} alt={item.product?.name} size="md" variant="rounded" />,
        name: (
          <MDTypography
            variant="caption"
            fontWeight="medium"
            title={item.product?.name}
            sx={{
              maxWidth: 120,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
              verticalAlign: "middle",
              cursor: item.product?.name?.length > 20 ? "pointer" : "default",
            }}
          >
            {item.product?.name}
          </MDTypography>
        ),
        quantity: (
          <MDTypography variant="caption" fontWeight="medium">
            {item.quantity}
          </MDTypography>
        ),
        price: (
          <MDTypography variant="caption" fontWeight="medium" color="info.main">
            {item.price}
          </MDTypography>
        ),
        attributes: (
          <MDBox display="flex" flexDirection="column" gap={0.5}>
            {attributes.length > 0 ? (
              attributes.map((attr, idx) => (
                <MDTypography key={idx} variant="caption" color="text">
                  {attr}
                </MDTypography>
              ))
            ) : (
              <MDTypography variant="caption" sx={{ color: "red" }}>
                لا يوجد
              </MDTypography>
            )}
          </MDBox>
        ),
      };
    }),
  };
}
